module.exports = __webpack_public_path__ + "img/рз_21.5e2f3563.png";